import styled from 'styled-components';
export const ChatDrawerContainer = styled.div `
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  iframe {
    flex-grow: 1;
    width: 100%;
    height: 100%;
    border: none;
    display: block;
    background-color: var(--color-contrast-white);
  }

  .chat-drawer_unavailable {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-size-xs);
    text-align: center;
    font-size: var(--font-size-sm);
  }

  /*
   * O esqueleto cobre o iframe em vez de substitui-lo: o MFE precisa continuar
   * carregando por baixo para chegar ao mount.
   */
  .chat-drawer_skeleton {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background-color: var(--color-contrast-white);
  }

  .chat-drawer_skeleton-messages {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .chat-drawer_skeleton-bubble {
    height: 56px;
    max-width: 78%;
    border-radius: 12px;
  }

  .chat-drawer_skeleton-bubble--sent {
    align-self: flex-end;
    max-width: 62%;
    height: 40px;
  }

  .chat-drawer_skeleton-input {
    height: 88px;
    border-radius: 12px;
  }

  /*
   * O brilho e um gradiente que atravessa a peca. 'prefers-reduced-motion'
   * desliga o movimento e deixa so o tom de fundo.
   */
  .chat-drawer_skeleton-bubble,
  .chat-drawer_skeleton-input {
    background-color: var(--color-neutral-background);
    background-image: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.85) 50%,
      transparent 100%
    );
    background-size: 220% 100%;
    background-repeat: no-repeat;
    animation: chat-drawer-shimmer 1.4s ease-in-out infinite;
  }

  @keyframes chat-drawer-shimmer {
    from {
      background-position: 160% 0;
    }
    to {
      background-position: -60% 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .chat-drawer_skeleton-bubble,
    .chat-drawer_skeleton-input {
      background-image: none;
      animation: none;
    }
  }
`;
//# sourceMappingURL=style.js.map